import React, { Component } from "react";
import {connect} from "react-redux";
import { setWidthsForWindowResize } from "../core/actions/interface";


class _InterfaceListener extends Component {

    constructor(props) {
        super(props);
        this.handleTableScroll = this.handleTableScroll.bind(this);
        this.handleFilterTableScroll = this.handleFilterTableScroll.bind(this);
        this.handleWindowResize = this.handleWindowResize.bind(this);
        this.handleTopScrollBarScroll = this.handleTopScrollBarScroll.bind(this);
    }

    handleTableScroll() {
        this.domRegisterTableScrollSticky.scrollLeft = this.domRegisterTableScrollWrapper.scrollLeft;
        this.domRegisterTableTopScrollBarWrapper.scrollLeft = this.domRegisterTableScrollWrapper.scrollLeft;
    }

    handleFilterTableScroll() {
        this.domRegisterTableScrollWrapper.scrollLeft = this.domRegisterTableScrollSticky.scrollLeft;
        this.domRegisterTableTopScrollBarWrapper.scrollLeft = this.domRegisterTableScrollSticky.scrollLeft;
    }

    handleTopScrollBarScroll() {
        this.domRegisterTableScrollSticky.scrollLeft = this.domRegisterTableTopScrollBarWrapper.scrollLeft;
        this.domRegisterTableScrollWrapper.scrollLeft = this.domRegisterTableTopScrollBarWrapper.scrollLeft;
    }

    handleWindowResize() {
        const { dispatch } = this.props;
        dispatch(setWidthsForWindowResize(
            this.domRegisterTableScrollWrapper.offsetWidth + "px",
            this.domMountNode.offsetWidth + "px"
        ));
    }

    componentDidMount() {

        this.domRegisterTableScrollWrapper = document.getElementById('register-table-scroll-wrapper');
        this.domRegisterTableScrollSticky = document.getElementById('register-table-scroll-sticky');
        this.domRegisterTableTopScrollBarWrapper = document.getElementById('register-top-scroll-bar-wrapper');
        this.domMountNode = document.getElementById('mountnode');

        this.domRegisterTableScrollWrapper.addEventListener('scroll', this.handleTableScroll);
        this.domRegisterTableScrollSticky.addEventListener('scroll', this.handleFilterTableScroll);
        this.domRegisterTableTopScrollBarWrapper.addEventListener('scroll', this.handleTopScrollBarScroll);
        window.addEventListener("resize", this.handleWindowResize);


    }

    componentWillUnmount() {
        this.domRegisterTableScrollWrapper.removeEventListener('scroll', this.handleTableScroll);
        this.domRegisterTableScrollSticky.removeEventListener('scroll', this.handleFilterTableScroll);
        this.domRegisterTableTopScrollBarWrapper.removeEventListener('scroll', this.handleTopScrollBarScroll);
        window.removeEventListener('resize', this.handleWindowResize);
    }

    componentDidUpdate(prevProps, prevState) {
        /**
         * Component will only update when tableHeaderIsFixed changes. When this happens we need
         * to resync the scroll bars based off the table, which is always visible in the DOM. We also need
         * to reset the window size due to things pushing in and out of DOM.
         */
        this.handleTableScroll();
        this.handleWindowResize();

    }

    render() {
        return null
    }
}

const mapStateToProps = (state) => ({
    tableHeaderIsFixed: state.mutableInterface.tableHeaderIsFixed
});

export const InterfaceListener = connect(mapStateToProps)(_InterfaceListener);
